function GetFirstAndLastDatesOfMonth(monthYearString) {
  if (monthYearString) {
    const [yearString, monthString] = monthYearString.split("-");
    const year = parseInt(yearString, 10);
    const month = parseInt(monthString, 10);
    const firstDateOfMonth = new Date(year, month - 1, 1);
    const lastDateOfMonth = new Date(year, month, 0);

    const formatDateString = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const firstDateString = formatDateString(firstDateOfMonth);
    const lastDateString = formatDateString(lastDateOfMonth);

    return { firstDate: firstDateString, lastDate: lastDateString };
  }
}


function getFirstAndLastDatesFromMonthName(monthYearString) {
  if (monthYearString) {
    const [monthName, yearString] = monthYearString.split("-");
    const year = parseInt(yearString, 10);

    // Convert month name to month index (0-11)
    const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth();

    const firstDateOfMonth = new Date(year, monthIndex, 1);
    const lastDateOfMonth = new Date(year, monthIndex + 1, 0);

    const formatDateString = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const firstDateString = formatDateString(firstDateOfMonth);
    const lastDateString = formatDateString(lastDateOfMonth);

    return { firstDate: firstDateString, lastDate: lastDateString };
  }
}


export { GetFirstAndLastDatesOfMonth, getFirstAndLastDatesFromMonthName }